import React from 'react';
import { Form } from 'react-form';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import _ from 'lodash';
import Translate from 'translate';
import { Checkbox as CheckboxComp } from 'material-ui';
import { FormInput } from 'react-form';

import NetworkService from 'services/NetworkService';
import { FormGroup, Text, Select, Checkbox, SelectCreatable } from 'components/FormElements/';
import { toggleLoading, toggleAlertError } from 'stores/actions/';
import { required, email } from 'constants/InputErrors';
import IntlMessages from 'util/IntlMessages'

class NetworkForm extends React.Component {
  isServerTypeEWS    = false;
  isServerTypeEXO    = false;
  isServerTypeOAUTH2 = false;
  constructor( props ) {
    super( props );

    this.state = {
      emailPortOptions: [
        { id: '10', name: '10' },
        { id: '143', name: '143' },
        { id: '995', name: '995' },
        { id: '993', name: '993' },
      ],
      data: {}
    };

    this.entityId = props.match.params.id;
    this.getData = this.getData.bind( this );
    this.submitForm = this.submitForm.bind( this );
    this.syncronizeContact = this.syncronizeContact.bind( this );
  }

  componentDidMount() {
    if( this.entityId ) this.getData()
  }

  getData() {
    this.props.toggleLoading( true );

    NetworkService.getNetwork( this.entityId ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.data ) {
        const resData = response.data;
        resData.emailSecurity = response.data.emailSecurity ? response.data.emailSecurity : 'None';
        this.setState( { data: response.data, emailPortOptions: [{id: response.data.emailPort, name: response.data.emailPort }, ...this.state.emailPortOptions] } )
      }
    })
    
  }

  syncServerType(){
    if(this.state.data.emailServerType === "gmail_oauth2"){
      this.isServerTypeOAUTH2 = true;
    }
    if(this.state.data.emailServerType === "ews"){
      this.isServerTypeEWS = true;
    }
    if(this.state.data.emailServerType === "exo"){
      this.isServerTypeEXO = true;
    }
  }

  syncronizeContact(){
    const { intl, toggleAlertError } = this.props;
    this.props.toggleLoading( true );

    NetworkService.syncContacts( this.entityId ).then( ( response ) => {
      this.props.toggleLoading( false );
      if( response.errors ) return toggleAlertError( intl.formatMessage( { id: 'unsuccessSync' } ) );
      if( response.data ) {
        return toggleAlertError( intl.formatMessage( { id: 'successSync' } ) );
      }
    } )
  }

  submitForm( data ) {
    const { history, toggleAlertError, toggleLoading } = this.props;
    this.formData = _.cloneDeep( data );
    toggleLoading( true );

    data.type = 'email';
    if(this.isServerTypeOAUTH2) data.active = true;
    let toSend = {
      ...data,
      emailSmtpAuth: data.emailSmtpAuth ? 1: 0,
      emailDefault: data.emailDefault ? 1: 0,
      
    };
    toSend.emailSecurity = data.emailSecurity === 'None' ? '' : data.emailSecurity;

    toSend.emailPort = data.emailPort ? data.emailPort.id : '';
    const promise = this.entityId ? NetworkService.updateNetwork( this.entityId, toSend ) :
      NetworkService.saveNetwork( toSend );

    promise.then( ( response ) => {
      toggleLoading( false );
      if( response.errors ) return toggleAlertError( response.errors );

      return history.push( `/configurations/email` )
    } )
    
  }

  setInboxValue( values, setValue ) {
    let val = '';
    if(values.emailServerType === "gmail_oauth2"){
      this.isServerTypeOAUTH2 = true;
    }else{
      this.isServerTypeOAUTH2 = false;
    }
    if(values.emailServerType === "ews"){
      this.isServerTypeEWS = true;
    }else {
      this.isServerTypeEWS = false;
    }
    if(values.emailServerType === "exo"){
      this.isServerTypeEXO = true;
    }else {
      this.isServerTypeEXO = false;
    }
    if( values.emailHostname ) {
      val = values.emailHostname
    }
    if( values.emailPort ) {
      val += `:${values.emailPort.id}`
    }
    if( values.emailServerType ) {
      val += `/${values.emailServerType}`
    }
    if(values.clientEchangeVersion){
      val +=  `/${values.clientEchangeVersion}`
    }  
    if( values.emailSecurity &&  values.emailSecurity !== 'None'  ) {
      val += `/${values.emailSecurity}`
    }
    if( values.emailCert ) {
      val += `/${values.emailCert}`
    }
    val = `{${val}}INBOX`;
    setValue( 'emailInbox', val )
  }

  selectedserver(value){
    console.log(value)
  }

  render() {
    this.syncServerType();
    return (
      <div className="box box-default">
        <div className="box-header text-capitalize">{this.entityId ? <Translate id="edit"/> :
          <Translate id="new"/>} <Translate
          id="emailAccount"/>
        </div>
        <div className="box-body">
          <Form
            defaultValues={this.formData || this.state.data}
            onSubmit={this.submitForm}
            validate={( values ) => {
              return {
                email: required( values.email ),
                emailHostname: !this.isServerTypeEXO && !this.isServerTypeOAUTH2 ? required( values.emailHostname ) : null,
                emailServerType: required( values.emailServerType ),
                emailFrom: !this.isServerTypeOAUTH2 ? required( values.emailFrom ) : null,
                emailUserName: this.isServerTypeEWS ? required( values.emailUserName ) : null,
                socialId: this.isServerTypeOAUTH2 ? required( values.socialId ) : null,
                socialSecret: this.isServerTypeOAUTH2 ? required( values.socialSecret ) : null,
                tokenSecret: this.isServerTypeOAUTH2 ? required( values.tokenSecret ) : null,
              }
            }}>
            {( { setValue, values, submitForm } ) =>
              <form onSubmit={submitForm} className="row">

                <FormGroup containerClass="col-md-6">
                  <label><Translate id="server"/></label>
                  <Select field="emailServerType" className="form-control"
                          options={[
                            { id: 'imap'        , name: 'imap' },
                            { id: 'ews'         , name:'ews' },
                            { id: 'exo'         , name:'Exchange Online OAUTH2' },
                            // { id: 'gmail_oauth2', name:'Gmail OAUTH2' }
                          ]}
                          onChange={() => this.setInboxValue( values, setValue )
                            }/>
                </FormGroup>
                <FormGroup containerClass="col-md-6">
                  <label><Translate id="email"/></label>
                  <Text field="email" className="form-control"/>
                </FormGroup>

                {
                  (!this.isServerTypeOAUTH2 && !this.isServerTypeEXO) &&
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="password" /></label>
                    <Text field="password" className="form-control" type="password" />
                  </FormGroup>
                }

                {this.isServerTypeEWS ?
                  <FormGroup containerClass="col-md-6">
                  <label><Translate id="emailUserName"/></label>
                  <Text field="emailUserName" className="form-control"
                        onChange={() => this.setInboxValue( values, setValue )}/>
                  </FormGroup>
                :
                null
                }

                {
                  !this.isServerTypeOAUTH2 &&
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="emailFrom"/></label>
                    <Text field="emailFrom" className="form-control"/>
                  </FormGroup>
                }

                <FormGroup containerClass={`col-md-${this.isServerTypeOAUTH2 ? '12' : '6'}`}>
                  <label><Translate id="alias"/></label>
                  <Text field="alias" className="form-control"/>
                </FormGroup>

                <div className="col-md-12">
                  <hr/>
                </div>

                {
                  (!this.isServerTypeOAUTH2 && !this.isServerTypeEXO) &&
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="hostname" /></label>
                    <Text field="emailHostname" className="form-control"
                      onChange={() => this.setInboxValue(values, setValue)} />
                  </FormGroup>
                }

                {
                  (!this.isServerTypeOAUTH2 && !this.isServerTypeEXO) &&
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="port" /></label>
                    <SelectCreatable field="emailPort" className="form-control"
                      options={this.state.emailPortOptions}
                      onChange={() => this.setInboxValue(values, setValue)} />
                  </FormGroup>
                }


                {this.isServerTypeEWS ?
                  <FormGroup containerClass="col-md-6">
                  <label><Translate id="clientEchangeVersion"/></label>
                  <Select field="clientExchangeVersion" className="form-control"
                          options={[
                            { id: 'Exchange2007', name: 'Exchange 2007' },
                            { id: 'Exchange2007_SP1', name: 'Exchange 2007 SP1' },
                            { id: 'Exchange2009', name: 'Exchange 2009' },
                            { id: 'Exchange2010', name: 'Exchange 2010' },
                            { id: 'Exchange2010_SP1', name: 'Exchange 2010 SP1' },
                            { id: 'Exchange2010_SP2', name: 'Exchange 2010 SP2' },
                            { id: 'Exchange2013', name: 'Exchange 2013' },
                            { id: 'Exchange2013_SP1', name: 'Exchange 2013 SP1' },
                            { id: 'Exchange2016', name: 'Exchange 2016' },
                          ]}
                          onChange={() => this.setInboxValue( values, setValue )}/>
                  </FormGroup>
                :
                null
                }
                
                {!this.isServerTypeEWS && !this.isServerTypeEXO && !this.isServerTypeOAUTH2 ?
                   <FormGroup containerClass="col-md-6">
                      <label><Translate id="security"/></label>
                   <Select field="emailSecurity" className="form-control"
                           options={[
                             { id: 'None', name: 'None' },
                             { id: 'ttl', name: 'ttl' },
                             { id: 'ssl', name: 'ssl' },
                           ]}
                           onChange={() => this.setInboxValue( values, setValue )}/>
                    </FormGroup>
                   :
                
                    null
                }

                {this.isServerTypeEXO || this.isServerTypeOAUTH2 ?
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id={`${this.isServerTypeOAUTH2 ? 'oauth2ClientID' : 'exoAppClientID'}`}/></label>
                    <Text field="socialId" className="form-control"/> 
                  </FormGroup>
                :
                null
                }
                
                {this.isServerTypeEXO || this.isServerTypeOAUTH2 ?
                   <FormGroup containerClass="col-md-6">
                      <label><Translate id={`${this.isServerTypeOAUTH2 ? 'oauth2ClientSecretID' : 'exoClientSecretID'}`}/></label>
                      <Text field="socialSecret" className="form-control"/> 
                    </FormGroup>
                   :
                
                    null
                }
                {this.isServerTypeEXO || this.isServerTypeOAUTH2 ?
                   <FormGroup containerClass="col-md-6">
                      <label><Translate id={`${this.isServerTypeOAUTH2 ? 'oauth2Token' : 'exoTenantID'}`}/></label>
                      <Text field="tokenSecret" className="form-control"/> 
                    </FormGroup>
                   :
                
                    null
                }

                { (!this.isServerTypeOAUTH2 && !this.isServerTypeEXO) &&
                  <FormGroup containerClass="col-md-6">
                    <label><Translate id="cert" /></label>
                    <Text field="emailCert" className="form-control"
                      onChange={() => this.setInboxValue(values, setValue)} />
                  </FormGroup>
                }

                {!this.isServerTypeEWS && !this.isServerTypeEXO && !this.isServerTypeOAUTH2 ?
                  <FormGroup containerClass="col-md-12">
                    <label><Translate id="inbox"/></label>
                    <Text field="emailInbox" className="form-control"/>
                  </FormGroup>
                    :
                    null
                }

                {!this.isServerTypeEWS && !this.isServerTypeEXO && !this.isServerTypeOAUTH2  ?
                  <FormGroup containerClass="col-md-3 mt-4">
                    <Checkbox field="emailSmtpAuth" label={<IntlMessages id="emailSmtpAuth"/>} labelStyle={{width: 'auto'}}/>
                  </FormGroup>
                    :
                    null
                }
    
                {!this.isServerTypeEWS && !this.isServerTypeEXO && !this.isServerTypeOAUTH2 ?
                  <FormGroup containerClass="col-md-3 mt-4">
                    <Checkbox field="emailDefault" label={<IntlMessages id="emailDefault"/>} labelStyle={{width: 'auto'}} />
                  </FormGroup>
                  :
                  null
                }
            
                <div className="col-md-12 text-right mt-4">
                  <div className="row">
                    <div className="col-md-6 text-left">
                      {(this.isServerTypeEWS) && 
                        <button type="button" onClick={this.syncronizeContact} className="btn btn-outline-secondary px-4 mr-2" ><Translate id="syncContacts"/></button>
                      }
                    </div>

                    <div className="col-md-6 text-right">
                      <Link to="/configurations/email">
                        <button className="btn btn-outline-secondary px-4 mr-2">
                          <Translate id="cancel"/>
                        </button>
                      </Link>
                      <button type="submit" className="btn btn-info px-4"><Translate id="save"/>
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            }
          </Form>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ( {
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleLoading: ( isLoading ) => {
    dispatch( toggleLoading( isLoading ) );
  },
} );

module.exports = connect(
  null,
  mapDispatchToProps
)( injectIntl(NetworkForm) );



// WEBPACK FOOTER //
// ./routes/app/routes/configuration/emails/edit/index.js